import { TOASTTYPE, Params } from '@/ui/Toast/Toast';
import { IntlShape } from 'react-intl';
import {
  doesFileResolutionExceedMaximum,
  doesFileSizeExceedMaximum,
} from 'src/utils/fileUtils';

/**
 * Triggers a file upload dialog and validates the selected file.
 *
 * @param toast function to show toast messages
 * @param intl function to format messages
 * @returns Promise<File | null> resolves with the selected file or null if no file was selected
 */
export const triggerFileUploadDialog = (
  toast: (params: Params) => void,
  intl: IntlShape,
) => {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = 'image/png, image/jpeg, video/mp4';

  return new Promise<File | null>((resolve) => {
    fileInput.addEventListener('change', async (event: Event) => {
      const target = event.target as HTMLInputElement;

      if (!target.files || target.files.length === 0) {
        resolve(null);
        return;
      }

      // multiselect is not configured
      const file = target.files[0];
      let isValid = true;

      if (await doesFileResolutionExceedMaximum(file)) {
        toast({
          title: intl.formatMessage({
            defaultMessage: 'The file you provided has too high resolution.',
            id: 'aqIDyE',
          }),
          mode: TOASTTYPE.Danger,
        });
        resolve(null);
        isValid = false;
      }

      if (doesFileSizeExceedMaximum(file)) {
        toast({
          title: intl.formatMessage({
            defaultMessage: 'The file you provided is too large.',
            id: 'oCApuQ',
          }),
          mode: TOASTTYPE.Danger,
        });
        resolve(null);
        isValid = false;
      }

      if (isValid) {
        resolve(file);
      }
    });

    // manually trigger file dialog
    fileInput.click();
  });
};
